import e from '@/lang/fr/error'

export default {
  contingent_hotelretrocession: {
    list: {
      page_title: 'Liste des configurations de rétrocession'
    },
    create: {
      page_title: 'Création configuration de rétrocession'
    },
    edit: {
      page_title: 'Edition configuration de rétrocession'
    },
    show: {
      page_title: 'Fiche configuration de rétrocession'
    },
    form: {
      655: e.error[655]
    }
  },
  hotel_hotelretrocession: {
    list: {
      page_title: 'Liste des configurations de rétrocession'
    },
    create: {
      page_title: 'Création configuration de rétrocession'
    },
    edit: {
      page_title: 'Edition configuration de rétrocession'
    },
    show: {
      page_title: 'Fiche configuration de rétrocession'
    },
    form: {
      655: e.error[655]
    }
  }
}
